import React from "react";

const Metter = ({ handlemetter }) => {
	return (
		<div>
			<svg
				id="mettersvg"
				viewBox="0 0 464 292"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="metter 1">
					<g id="layer3">
						<g id="g4265">
							<g id="g4334">
								<g id="g4294">
									<g id="metter">
										<path
											id="path4559-3"
											d="M229.42 21.9918C113.359 21.9918 19.2892 117.252 19.2892 234.782C19.2892 243.129 19.7743 251.345 20.6977 259.442L229.414 259.442L438.136 259.442C439.06 251.345 439.545 243.128 439.545 234.782C439.545 117.257 345.473 21.9918 229.414 21.9918H229.42Z"
											fill="white"
											stroke="#040000"
											stroke-width="2"
										/>
									</g>
									<g id="g3491">
										<path
											id="path3092-3"
											d="M229.135 38.1169V110.005C215.555 110.005 202.483 112.244 190.225 116.386L169.09 48.3868C187.744 41.8607 207.866 38.7263 229.137 38.1169H229.135Z"
											fill="#FFD001"
											stroke="#050000"
										/>
										<path
											id="path3117-3"
											d="M232.867 38.4551C251.356 38.7071 270.216 42.1599 289.35 48.0487L268.052 116.386C255.805 112.248 242.748 110.009 229.182 110.005V38.4551C230.411 38.4429 231.634 38.4383 232.867 38.4551Z"
											fill="#F7AC15"
											stroke="#050000"
										/>
										<path
											id="path3119-6"
											d="M289.267 48.3816C308.033 54.5464 326.054 64.3939 343.605 76.9509L303.195 135.02C292.616 127.01 280.79 120.678 268.091 116.383L289.267 48.3816Z"
											fill="#F59502"
											stroke="#050000"
										/>
										<path
											id="path3121-2"
											d="M343.439 77.2417C359.461 89.1577 373.747 104.31 386.722 121.913L331.13 164.048C323.331 152.916 313.889 143.111 303.193 135.013L343.439 77.2403V77.2417Z"
											fill="#F66013"
											stroke="#050000"
										/>
										<path
											id="path3123-8"
											d="M386.442 122.128C398.153 138.628 407.252 157.663 414.379 178.59L349.11 200.693C344.946 187.436 338.86 175.082 331.133 164.052L386.442 122.128Z"
											fill="#F93817"
											stroke="#050000"
										/>
										<path
											id="path3125-2"
											d="M414.053 178.725C420.305 198.377 423.308 219.576 423.891 241.982H355.383C355.345 227.652 353.126 213.872 349.107 200.948L414.052 178.724L414.053 178.725Z"
											fill="#FA0001"
											stroke="#050000"
										/>
										<path
											id="path3129-8"
											d="M168.965 48.0435L190.221 116.381C177.516 120.674 165.702 127.007 155.117 135.019L114.911 77.2038C130.719 64.9803 148.915 55.483 168.965 48.0435Z"
											fill="#F4E216"
											stroke="#050000"
										/>
										<path
											id="path3131-9"
											d="M114.676 76.9577L155.085 135.027C144.397 143.121 134.983 152.936 127.188 164.061L71.8791 122.095C83.2953 105.371 97.8118 90.5005 114.676 76.9577Z"
											fill="#D8EE21"
											stroke="#050000"
										/>
										<path
											id="path3133-2"
											d="M71.5954 121.925L127.187 164.06C119.464 175.081 113.335 187.413 109.17 200.658L44.2646 178.64C50.1709 159.052 59.5651 140.243 71.5954 121.923V121.925Z"
											fill="#B1D211"
											stroke="#050000"
										/>
										<path
											id="path3135-6"
											d="M43.9329 178.59L109.162 200.84C105.14 213.728 102.929 227.473 102.886 241.764H34.7016C34.5197 221.094 37.9156 200.035 43.9332 178.591L43.9329 178.59Z"
											fill="#9BB714"
											stroke="#050000"
										/>
									</g>
								</g>
							</g>
							<g id="g4315">
								<g id="arrow" style={handlemetter}>
									<path
										id="rect4171-4-2"
										d="M224.702 88.537C225.866 70.6682 229.869 70.8057 231.201 88.3958L243.081 254.094L215.788 254.687L224.702 88.537Z"
										fill="#1A1A1A"
									/>
									<path
										id="path4191-8"
										d="M246.899 253.465C246.909 258.562 244.99 263.506 241.562 267.209C238.135 270.912 233.48 273.071 228.623 273.211C223.765 273.351 219.102 271.461 215.66 267.956C212.218 264.451 210.278 259.619 210.267 254.522C210.257 249.425 212.177 244.481 215.604 240.778C219.032 237.075 223.686 234.916 228.544 234.776C233.401 234.636 238.064 236.526 241.506 240.031C244.949 243.536 246.888 248.368 246.899 253.465Z"
										fill="#1A1A1A"
									/>
									<path
										id="path4198-5"
										d="M241.355 253.627C241.362 257.18 240.024 260.626 237.635 263.208C235.245 265.789 232.001 267.294 228.614 267.392C225.228 267.489 221.978 266.172 219.578 263.728C217.179 261.285 215.827 257.916 215.82 254.363C215.812 250.811 217.15 247.364 219.54 244.783C221.929 242.202 225.174 240.697 228.56 240.599C231.946 240.501 235.196 241.819 237.596 244.262C239.995 246.706 241.348 250.074 241.355 253.627Z"
										fill="#FF0000"
										stroke="white"
										stroke-width="0.581001"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
	);
};

export default Metter;
